import React from "react";

import {
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Add as AddIcon } from "@mui/icons-material";
import BoosterForm from "./BoosterForm";

// ----------------------------------------------------------------------
export default function BoosterEditBtn({ editData, addLabel }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const getTitle = () => {
    try {
      if (editData && editData.id) {
        return `Modification`;
      } else {
        return addLabel;
      }
    } catch (error) {
      return "";
    }
  };

  const getIcon = () => {
    try {
      if (editData && editData.id) {
        return (
          <IconButton
            aria-label="details"
            size="small"
            onClick={handleClickOpen}
          >
            <EditIcon size="small" />
          </IconButton>
        );
      } else {
        return (
          <Button variant="contained" color="primary" onClick={handleClickOpen}>
            <AddIcon />
            {getTitle()}
          </Button>
        );
      }
    } catch (error) {
      return <></>;
    }
  };
  return (
    <div>
      {getIcon()}
      <Dialog open={open} fullWidth maxWidth="xl">
        <DialogTitle> {getTitle()}</DialogTitle>
        <DialogContent>
          <BoosterForm editData={editData} onComplete={handleClose} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
